import { ajaxInstance} from "../utils/axios";


export default function usePrograms(){
    let getProgramUrl = `api/program/index`
    let modifyProgramUrl = `api/program/modify`
    let createProgramUrl = `api/program/create`


    const getProgram = (currentIbNumber) => {
        let params = {
            "ibnumber": currentIbNumber
        }
        return new Promise((resolve, reject) => {
            ajaxInstance.get(getProgramUrl, { params: params
            }).then((response) => {
                const data = response.data
                console.log('Get ProgramHook', data.data)
                if (response.status === 200){
                    resolve(data.data)
                }
            }).catch((error) => {
                if (error.response.status !== 500){
                    const data = error.response.data
                    const errors = data.errors
                    console.log('Error in get ProgramHook', errors)
                    reject(errors)
                }else{
                    console.log('Error in get ProgramHook', error)
                    reject(error)
                }
            })
        })
    }
    const modifyProgram = (programsPayload, ib_number, erasedGroups=null) => {
        return new Promise((resolve, reject) => {
            let new_filtered  = { ...programsPayload}
            Object.keys(programsPayload).forEach((groupName) => {
                Object.entries(programsPayload[groupName]).forEach((key_value_pair) => {
                    const programId = key_value_pair[0]
                    const program = key_value_pair[1]
                    // its a created agreement
                    if(programId[programId.length -1] === 'n'){
                        new_filtered[groupName][programId] = {created: true, group: groupName , ...program}
                    }else if(program.modified === undefined){
                        delete new_filtered[groupName][programId]
                    }else if(program.modified){
                        new_filtered[groupName][programId] = {id: programId, group: groupName, ...program}
                    }else if(program.erased){
                        new_filtered[groupName][programId] = {id: programId, group: groupName, ...program}
                    }
                })
            })
            let all_programs_to_be_updated_created = []
            Object.keys(new_filtered).forEach((groupName) => {
                Object.values(new_filtered[groupName]).forEach((program) => {
                    all_programs_to_be_updated_created.push(program)
                })
            })
            let payload = { ib_number: ib_number,programs: all_programs_to_be_updated_created, erasedGroups: erasedGroups}
            ajaxInstance.post(modifyProgramUrl, payload).then((response) => {
                const data = response.data
                console.log('Post ProgramHook', data.data)
                if (response.status === 200){
                    resolve(true)
                }
            }).catch((error) => {
                if (error.response.status !== 500){
                    const data = error.response.data
                    const errors = data.errors
                    console.log('Error in post ProgramHook', errors)
                    reject(errors)
                }else{
                    console.log('Error in post ProgramHook', error)
                    reject('Algo ha ido mal, por favor intenta de nuevo')
                }
            })
        })
    }

    const createProgram = (ibnumber, allPrograms) => {
        return new Promise((resolve, reject) => {
            ajaxInstance.post(createProgramUrl,{
                "ib_number": ibnumber,
                "programs": allPrograms
            }).then((response) => {
                const data = response.data
                console.log('Post ProgramHook', data.data)
                if (response.status === 200){
                    resolve(data.data)
                }
            }).catch((error) => {
                if (error.response.status !== 500){
                    const data = error.response.data
                    const errors = data.errors
                    console.log('Error in post ProgramHook', errors)
                    reject()
                }else{
                    console.log('Error in post ProgramHook', error)
                    reject()
                }
            })
        })
    }

    return {
        getProgram,
        modifyProgram,
        createProgram,
    }

}